import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { translate } from '../../helpers/translate.js';
import { launchTypes } from '../../store/elearning/helpers.js';

@customElement('sdb-preview-url-player')
class SdbPreviewUrlPlayer extends LitElement
 {

    @property({ type: String })
    accessor launchUrl = null;

    @property({ type: Number })
    accessor launchType = launchTypes.LAUNCHTYPE_REGULAR;

    get contentWindowIsOpen() {
        return this.contentWindow && !this.contentWindow.closed;
    }

    constructor() {
        super();
        this.contentWindow = null;
    }

    static get styles() {
        return css`
            .blackbox-frame {
                width: 100%;
                height: 100%;
                border: none;
                margin: 0;
                padding: 0;
                background: #f7f7f7;
            }

            .newwindow {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .container {
                width: 70%;
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: space-between;
            }

            .message {
                font-family: 'Source Sans Pro', 'sans-serif';
            }

            #start_button {
                margin-top: 20px;
            }
        `;
    }

    render() {
        if (this.launchType >= launchTypes.LAUNCHTYPE_NEWWINDOW) {
            if (!this.contentWindowIsOpen) {
                this._openNewWindow();
            }

            return html`
                <div class="newwindow">
                    <div class="container">
                        <div class="message">
                            ${translate(this.contentWindowIsOpen
                                ? 'newWindowOpenedMessage'
                                : 'newWindowMessage')
                            }
                        </div>
                        <sdb-content-button
                            id="start_button"
                            label=${translate('startInNewWIndow')}
                            primary
                            ?hidden=${this.contentWindowIsOpen}
                            @click=${this._openNewWindow}>
                        </sdb-content-button>
                    </div>
                </div>
            `;
        }

        return html`
            <iframe
                class="blackbox-frame"
                src=${this.launchUrl}
                frameborder="0"
                allowfullscreen
                referrerpolicy="strict-origin-when-cross-origin"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; microphone; picture-in-picture; fullscreen"
                loading="lazy">
            </iframe>
        `;
    }

    _openNewWindow() {
        if (this.contentWindowIsOpen) {
            return;
        }

        let options = '';
        if (this.launchType === launchTypes.LAUNCHTYPE_NEWCHROMELESSWINDOW) {
            const w = window.screen.availWidth;
            const h = window.screen.availHeight;
            options = `status=0,toolbar=0,menubar=0,resizable=yes,width=${w},height=${h},left=0,top=0`;
        }

        this.contentWindow = window.open(this.launchUrl, 'contentWindow', options);

        this.externallyClosed = false;
        const timer = setInterval(() => {
            if (this.contentWindow.closed) {
                clearInterval(timer);

                this.dispatchEvent(new CustomEvent('close', {
                    composed: true,
                    bubble: true,
                }));
            }
        }, 200);
    }
}
